import { render, staticRenderFns } from "./FullScreenPdfView.vue?vue&type=template&id=ad273e4e&"
import script from "./FullScreenPdfView.vue?vue&type=script&lang=js&"
export * from "./FullScreenPdfView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports